import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuccess = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 70,
	height: 70,
	viewBox: "0 0 70 70",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 35,
		cy: 35,
		r: 35,
		fill: "#59B300"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M21 34.8152L30.4554 44.3327L49 25.666",
		stroke: "white",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgSuccess;
